export default "__VITE_ASSET__rF1LxQ0P__"